export default __webpack_public_path__ + "static/media/Mask Group 163.d9ee0381.svg";